import type { CSSProperties, SxProps } from "@mui/material";
import { INK, STATUS_BADGE } from "@/theme/tokens";

export enum MultiSizePopupState {
	HIDDEN = "HIDDEN",
	MINIMIZED = "MINIMIZED",
	MAXIMIZED = "MAXIMIZED",
}

export type PreviousStateType = MultiSizePopupState.MINIMIZED | MultiSizePopupState.MAXIMIZED;

export const headerTypographyStyle = {
	fontSize: "18px",
	fontWeight: 600,
	lineHeight: "24px",
	// brand fallback — does not re-tint with user theme
	color: STATUS_BADGE.BRAND_FALLBACK,
} as const satisfies SxProps;

export const headerActionIconButtonsStyle = {
	...headerTypographyStyle,
	color: INK.SECONDARY,
} as const satisfies SxProps;

export const minimizedViewMaxHeight: CSSProperties["maxHeight"] = 600;
export const minimizedViewMaximumContentWidth: CSSProperties["maxWidth"] = 450;
export const minimizedViewMaximumTitleWidth = minimizedViewMaximumContentWidth - 150;
